/** @jsx jsx */
import { Swiper, SwiperSlide } from "swiper/react";
import { useEffect, useState } from "react";
import { jsx } from "@emotion/react";
import "swiper/swiper-bundle.min.css";
import SwiperCore, { Autoplay, Keyboard, Navigation, Pagination } from "swiper";
import { Col, Container, Row } from "react-bootstrap";
import { carouselStoreSwipe } from "../assets/styles/Slider.styles";
import Icon1 from '../assets/images/LP-arabe/ico-calendario/icon-1.svg'
import Icon2 from '../assets/images/LP-arabe/ico-calendario/icon-2.svg'
import Icon3 from '../assets/images/LP-arabe/ico-calendario/icon-3.svg'
import Icon4 from '../assets/images/LP-arabe/ico-calendario/icon-4.svg'
import Icon5 from '../assets/images/LP-arabe/ico-calendario/icon-5.svg'
import Icon6 from '../assets/images/LP-arabe/ico-calendario/icon-6.svg'
import Icon7 from '../assets/images/LP-arabe/ico-calendario/icon-7.svg'

SwiperCore.use([Pagination]);

const SliderHome = () => {
    const [isMobile, setIsMobile] = useState(false)
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth < 600)
          }
          if (typeof window !== 'undefined') {
            setIsMobile(window.innerWidth < 600)
            window.addEventListener('resize', handleResize)
          }
          return () => {
            if (typeof window !== 'undefined') {
              window.removeEventListener('resize', handleResize)
            }
          }
        }, [])
  return (
    <section style={{position: 'relative', overflow: 'hidden',paddingBottom: '50px'}} css={carouselStoreSwipe}>
      <Container  >
        <Row className="pb-5 pt-5">
          <Col data-aos="fade-left" data-aos-duration="1500" data-aos-easing="ease-in-sine" md={12} className="slideCarrousel order-1 order-md-2">
            <Swiper
              slidesPerView={'auto'}
              spaceBetween={isMobile ? 0 : 30}
              loop={true}
              keyboard={{
                enabled: true,
              }}
              pagination={{
                  clickable: true,
              }}
              autoplay={{
                  delay: 5000,
                  disableOnInteraction: false,
                }}
              mousewheel={true}
              modules={[Autoplay,Keyboard, Pagination, Navigation]}
                 className="mySwiper"

            >
              <SwiperSlide >
                <div className="box-calendario" >
                  <img src={Icon1} />
                  <h3>16 de janeiro</h3>
                  <h2>Miʿrāj</h2>
                  <p>Celebração espiritual e reflexão.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide >
                <div className="box-calendario" >
                  <img src={Icon2} />
                  <h3>02 de fevereiro</h3>
                  <h2>Laylat al-Bara'ah</h2>
                  <p>Atividades de oração e caridade.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide >
                <div className="box-calendario" >
                  <img src={Icon3} />
                  <h3>01 de Março </h3>
                  <h2>Início do Ramadã</h2>
                  <p>Início do mês sagrado do jejum, reflexões.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide >
                <div className="box-calendario" >
                  <img src={Icon3} />
                  <h3>27 de Março </h3>
                  <h2>Lailat al-Qadr</h2>
                  <p>Celebração especial noturna, oração súplicas.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide >
                <div className="box-calendario" >
                  <img src={Icon4} />
                  <h3>31 de Março</h3>
                  <h2>Eid al-Fitr</h2>
                  <p>Festa com atividades culturais, brincadeiras.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide >
                <div className="box-calendario" >
                  <img src={Icon3} />
                  <h3>15-20 de JUNHO</h3>
                  <h2>Hajj</h2>
                  <p>Semana de estudos sobre o Hajj, encenação no salão nobre da mesquita.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide >
                <div className="box-calendario" >
                  <img src={Icon5} />
                  <h3>18 de JUNHO</h3>
                  <h2>Eid al-Adha</h2>
                  <p>Evento com apresentações e culinária, refeitório da escola.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide >
                <div className="box-calendario" >
                  <img src={Icon3} />
                  <h3>07 de JULHO</h3>
                  <h2>Ano Novo Islâmico</h2>
                  <p>Início do novo ano Hijri, apresentação, teatro.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide >
                <div className="box-calendario" >
                  <img src={Icon6} />
                  <h3>16 de JULHO</h3>
                  <h2>Hégira de Meca para Medina, Ashura</h2>
                  <p>Atividades de reflexão histórica, gravação de conteúdo.</p>
                </div>
              </SwiperSlide>
              <SwiperSlide >
                <div className="box-calendario" >
                  <img src={Icon7} />
                  <h3>07 de SETEMBRO</h3>
                  <h2>Mawlid al-Nabi</h2>
                  <p>Evento com apresentações e poesia, nasheed.</p>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default SliderHome;
